// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"8bbf32fe","267":"8bbf32fe","809":"8bbf32fe"}[chunkId] + ".chunk.css";
};